import React from 'react';
import { Skeleton, TableCell, TableRow } from '@mui/material';

interface TableSkeletonRowsProps {
  columnCount: number;
  rowCount?: number;
  includeSelection?: boolean;
  includeActions?: boolean;
}

const skeletonWidths = ['72%', '88%', '64%', '80%', '56%'];

export default function TableSkeletonRows({
  columnCount,
  rowCount = 8,
  includeSelection = false,
  includeActions = false,
}: TableSkeletonRowsProps): React.JSX.Element {
  return (
    <>
      {Array.from({ length: rowCount }, (_, rowIndex) => (
        <TableRow
          key={`table-skeleton-row-${rowIndex}`}
          data-testid="table-skeleton-row"
          aria-hidden="true"
        >
          {includeSelection && (
            <TableCell padding="checkbox">
              <Skeleton animation="wave" variant="circular" width={20} height={20} />
            </TableCell>
          )}
          {Array.from({ length: columnCount }, (_, columnIndex) => (
            <TableCell key={`table-skeleton-cell-${rowIndex}-${columnIndex}`}>
              <Skeleton
                animation="wave"
                variant="text"
                width={skeletonWidths[(rowIndex + columnIndex) % skeletonWidths.length]}
                height={24}
              />
            </TableCell>
          ))}
          {includeActions && (
            <TableCell>
              <Skeleton animation="wave" variant="circular" width={28} height={28} />
            </TableCell>
          )}
        </TableRow>
      ))}
    </>
  );
}

